module.exports = __webpack_public_path__ + "img/dollar_cup.2c155b65.svg";